/* eslint-disable jsx-a11y/no-static-element-interactions */
import { sortBy, getOr } from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';
import classNames from 'classnames';
import { ControlPanelSteps } from '@upstart/harmony/lib/flow-utils';
import { CLIENT_TYPE } from '@upstart/harmony/lib/constants';
import FlowListItemCheckbox from './FlowListItemCheckbox';

class FlowListItem extends Component {
  constructor(props) {
    super(props);
    const { flowListType } = this.props;

    this.AVAILABLE_CHECKBOXES = {};
    if (flowListType === CLIENT_TYPE.IN_STORE) {
      // Customer Info can only dependent on vehicle selection
      this.AVAILABLE_CHECKBOXES[
        ControlPanelSteps[flowListType].CUSTOMER_INFO.id
      ] = [ControlPanelSteps[flowListType].VEHICLE_SELECTION];
      // Vehicle selection an only dependent on customer info
      this.AVAILABLE_CHECKBOXES[
        ControlPanelSteps[flowListType].VEHICLE_SELECTION.id
      ] = [ControlPanelSteps[flowListType].CUSTOMER_INFO];
    }
  }

  getDependentSteps = item => {
    const dependentArr = this.props.flow.filter(
      e => e.depends && e.depends.includes(item.id),
    );

    if (!dependentArr.length) return [];

    const result = [];
    dependentArr.forEach(step => {
      const steps = this.getDependentSteps(step);
      result.push(...steps);
    });
    return dependentArr.concat(result);
  };

  getCheckboxSteps = () => {
    const { flow, item } = this.props;
    const availableArr = getOr(
      flow,
      item.id,
    )(this.AVAILABLE_CHECKBOXES).filter(i => i.id !== item.id);
    return sortBy(['name'])(availableArr);
  };

  removeItem = () => {
    const { flowListType } = this.props;
    const flow = this.props.flow

      // Remove the flow step from the list
      .filter(item => item.id !== this.props.item.id)

      // Cleanup the dependencies on the removed step
      .map(item => {
        if (!item.depends) return item;
        const depends = item.depends.filter(i => i !== this.props.item.id);
        return { ...item, depends };
      });
    this.props.onChange(flowListType, flow);
  };

  updateItem = newItem => {
    const { flow, flowListType, onChange } = this.props;
    // Update an item using its id
    onChange(
      flowListType,
      flow.map(item => (item.id === newItem.id ? newItem : item)),
    );
  };

  isCheckboxDisabled = (baseItem, checkboxItem) => {
    const { flowListType } = this.props;
    const dependent = this.getDependentSteps(baseItem).map(e => e.id);

    switch (checkboxItem.id) {
      // Forms library is always disabled for In Store
      case ControlPanelSteps[flowListType].FORM_LIBRARY &&
        ControlPanelSteps[flowListType].FORM_LIBRARY.id:
        return true;

      // Disable the checkbox in case of dependencies to avoid a loop
      default:
        return dependent.includes(checkboxItem.id);
    }
  };

  renderCheckbox = (checkboxItem, index) => (
    <FlowListItemCheckbox
      key={index}
      baseItem={this.props.item}
      checkboxItem={checkboxItem}
      onItemChange={this.updateItem}
      disabled={this.isCheckboxDisabled(this.props.item, checkboxItem)}
    />
  );

  render() {
    const { item, flowListType } = this.props;
    const isLocked =
      ControlPanelSteps[flowListType][item.id] &&
      ControlPanelSteps[flowListType][item.id].locked;
    return (
      <div
        key={item.name}
        className={classNames({ 'item-locked': isLocked })}
        data-id={item.id}
        data-locked={isLocked}
      >
        <div className="draggable-item-title">
          <div className="draggable-item-name">{item.name}</div>
          {!item.required && (
            <Icon
              name="delete"
              size="large"
              className="icon-delete"
              onClick={this.removeItem}
            />
          )}
        </div>
        {flowListType === CLIENT_TYPE.IN_STORE && (
          <div className="draggable-item-checkbox-container">
            {this.getCheckboxSteps().map(this.renderCheckbox)}
          </div>
        )}
      </div>
    );
  }
}

FlowListItem.propTypes = {
  flow: PropTypes.array,
  flowListType: PropTypes.string,
  item: PropTypes.object,
  onChange: PropTypes.func,
};

export default FlowListItem;
